import * as React from 'react';
import { connect } from 'react-redux';
import DocumentMeta from 'react-document-meta';
import { withRouter } from 'react-router';
import last from 'lodash/last';
import NavBar from './NavBar';
import isEmpty from 'lodash/isEmpty';
const styles = require('./mainLayout.less') as any;

interface MainLayoutProps {
		router: any;
		routes: any;
		location: Location;
		user: any;
		getAccount: any;
		isAuthenticated: any;
		getProfile: any;
		haveCredentials: boolean;
		profile: any;
		findLocation;
    browser: any;
}

import { isPanelView, isPlaceRoute, isSearchRoute, getNavPosition } from './utils';
import SearchMap from '../components/SearchMap/SearchMap';
import Header from './Header';
import classNames from 'classnames';
import { MuiThemeProvider, muiTheme } from '../components/fields';
import { getAccount } from '../models/Account';
import { getProfile } from '../models/Profile';
import { findLocation } from '../models/Location';

const mapStateToProps = (state, ownProps) => ({
//		haveCredentials: state.auth,
    //		isAuthenticated: state.auth,
    isAuthenticated: !isEmpty(get(state, 'account.data')),
		user: state.account,
		profile: state.profile,
    browser: state.browser
});

const dataRequested = (model) => model && (model.data || model.inProgress);
import get from 'lodash/get';
@connect(mapStateToProps, { getAccount, getProfile, findLocation })
class MainLayout extends React.Component< MainLayoutProps, any> {
		constructor(props) {
				super(props);
				this.state = {error: null};
		}

		componentWillMount() {
        this.props.findLocation();
				const { user, profile, isAuthenticated } = this.props;

				if (!isAuthenticated) {
						if (!dataRequested(user)) this.props.getAccount();
						if (!dataRequested(profile)) this.props.getProfile();
				}
		}

	unstable_handleError(e) {
		this.setState({error: e});
	}

	render() {
				const { children, isAuthenticated, location, routes: active_routes, browser, profile } = this.props;
				const { error } = this.state;
        const profileCompleted = get(profile, 'data.completion', Infinity) > 6;
        const navPosition = getNavPosition(browser, active_routes, location)
		    this.props.router.isActive('/place')
        // TODO: routes is active_routes because of scoping problem. TS error?
        const route = last(active_routes) as any;
    const viewIsPanel = isPanelView(active_routes);
		const columns = browser.lessThan.searchViewLimit ? 'oneColumn' : 'twoColumn'
    const classes = [
      styles.accessplace,
			navPosition, columns,
			isPlaceRoute(active_routes) && 'placeView',
			isSearchRoute(active_routes) && 'searchView',
      viewIsPanel ? styles.panelView : styles.PrimaryView,
    ];

		const title = route.title
				return (
					<MuiThemeProvider muiTheme={muiTheme}>
						<div className={classNames(classes)}>
							<DocumentMeta title={title} />
							<SearchMap location={location} />
              {!viewIsPanel && <div className={styles.Primary}>
                <Content {...{isAuthenticated, active_routes, error, children, profileCompleted,
															showSubtitle: !browser.lessThan.searchViewLimit,
															showNav: navPosition === 'header'}} />
              </div>}
                    {(viewIsPanel) && (
											 <Content {...{isAuthenticated, active_routes, error, children, profileCompleted,
																		 showNav: false, showSubtitle: false}} />)}
										{navPosition && navPosition !== 'header' && (
											 <NavBar {...{isAuthenticated, active_routes, navPosition, profileCompleted}} />)}
						</div>
					</MuiThemeProvider>
				);
		}
}

const Content = ({ isAuthenticated, active_routes, error, children, profileCompleted, showNav, showSubtitle }) => (
    <div className={styles.main}>
        <Header {...{isAuthenticated, active_routes, profileCompleted, showSubtitle, showNav}} />
				<div className={classNames(styles.content)}>
						{error ? <RenderingError error={error} />: children}
				</div>
		</div>
);

export default withRouter(MainLayout);

// TODO: Use mozilla/source-map
// TODO: redbox-react
// TODO: sourcemapped-stacktrace
const RenderingError = ({error}) => (
	__DEV__ ? (
		<div>
			An error has occurred:
			<div>{error.message}</div>
			<div>{error.stack}</div>
		</div>)
	: <div> There was an error displaying this page. </div>
);



// WEBPACK FOOTER //
// ./src/app/Layouts/MainLayout.tsx